<script lang="ts">
  import type { Snippet } from "svelte";

  type Variant = "primary" | "ghost" | "subtle" | "danger";
  type Size = "sm" | "md";

  let {
    variant = "primary",
    size = "md",
    type = "button",
    disabled = false,
    href,
    onclick,
    title,
    class: cls = "",
    children,
  }: {
    variant?: Variant;
    size?: Size;
    type?: "button" | "submit";
    disabled?: boolean;
    href?: string;
    onclick?: (e: MouseEvent) => void;
    title?: string;
    class?: string;
    children: Snippet;
  } = $props();

  const base =
    "inline-flex items-center justify-center gap-2 rounded-md font-medium transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/60";
  const sizes: Record<Size, string> = {
    sm: "px-3 py-1.5 text-sm",
    md: "px-4 py-2 text-sm",
  };
  const variants: Record<Variant, string> = {
    primary: "bg-accent hover:bg-accent-hi text-white",
    ghost: "border border-line-strong text-ink hover:border-white/35 hover:bg-white/5",
    subtle: "bg-white/5 hover:bg-white/10 text-ink",
    danger: "border border-down/40 text-down hover:bg-down-soft",
  };

  const klass = $derived(`${base} ${sizes[size]} ${variants[variant]} ${cls}`);
</script>

{#if href}
  <a {href} {onclick} {title} class={klass}>{@render children()}</a>
{:else}
  <button {type} {disabled} {onclick} {title} class={klass}>{@render children()}</button>
{/if}
